(function (window, document, undefined) {

    let iFrame = document.getElementById('resavio-iframe');
    let loaded = false;

    function adjustViewport() {
        const yPosition = window.scrollY + iFrame.getBoundingClientRect().top;
        window.scrollTo(0, yPosition);
    }

    function resizeFrame(height) {
        iFrame.style.height = height + 'px';
    }

    function handleMessage(e) {
        switch (e.data.action) {
            case 'RESIZE':
                resizeFrame(e.data.height);
                break;
            case 'LOAD':
                resizeFrame(e.data.height);
                if (loaded) {
                    adjustViewport();
                } else {
                    loaded = true;
                }
                break;
        }
    }

    window.addEventListener('message', handleMessage, false);

})(window, document);

